import { registerPlugin, mergeConfig } from '@modern-js/runtime/plugin';
import { getGlobalAppConfig, getGlobalLayoutApp, getCurrentEntryName } from '@modern-js/runtime/context';

let runtimeConfig;

const plugins = [];

import { routerPlugin } from '@modern-js/runtime/router';

plugins.push(routerPlugin(mergeConfig({"serverBase":["/"]}, (runtimeConfig || {})['router'], ((runtimeConfig || {})['routerByEntries'] || {})['index'], (getGlobalAppConfig() || {})['router'])));

registerPlugin(plugins, runtimeConfig);
